import { configureStore } from '@reduxjs/toolkit';
import authReducer from 'features/auth/slices/authSlice';
import orderReducer from 'features/orders/slices/orderSlice';
import userReducer from 'features/settings/slices/userSlice';
import aoiReducer from 'features/explore/slices/aoiSlice';
import mapReducer from 'features/explore/slices/mapSlice';
import catalogReducer from 'features/explore/slices/catalogSlice';
import taskingReducer from 'features/explore/slices/taskingSlice';
import notificationReducer from './notificationSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    orders: orderReducer,
    users: userReducer,
    aoi: aoiReducer,
    map: mapReducer,
    catalog: catalogReducer,
    tasking: taskingReducer,
    notification: notificationReducer,
  },
});

export default store;
